export default function copyToClipboard(text, completion) {
  navigator.clipboard.writeText(text)
    .then(() => {
      console.log('Text copied to clipboard');
      document.getElementById( 'copyConfirm' ).style.display = 'block';
      completion(true, null);
    })
    .catch(err => {
      console.error('Failed to copy text: ', err);
      completion(false, null);
    });
}
